import { useReducer, useEffect, type Reducer, type Dispatch } from "react";

export function useStorageReducer<S, A>(
  reducer: Reducer<S, A>,
  initialState: S,
  key: string,
) {
  function init(initialArg: S) {
    try {
      const storedItem = window.localStorage.getItem(key);
      return storedItem ? JSON.parse(storedItem) : initialArg;
    } catch (error) {
      console.warn(`Error parsing localStorage key "${key}":`, error);
      return initialArg;
    }
  }

  const [state, dispatch] = useReducer(reducer, initialState, init);

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(state));
    } catch (error) {
      console.warn(`Error setting localStorage key "${key}":`, error);
    }
  }, [state, key]);

  return [state, dispatch] as const;
}
